import createReducer from "./createReducer";
// import { BladeInfo } from "rhombus-react";

const BladeInfo = {
	HANDLERS:{},
};

export const BLADE_ACTIONS = {
	OPEN_BLADE:"OPEN_BLADE",
	CLOSE_BLADE:"CLOSE_BLADE",
};

export function openBlade(blade, extra){
	return (dispatch) => {
		return dispatch({
			type:    BLADE_ACTIONS.OPEN_BLADE,
			payload: { blade, extra },
		});
	};
}

export function closeBlade(){ return dispatch => dispatch({ type:BLADE_ACTIONS.CLOSE_BLADE }); }

const IT = {
	edit:   { isFullscreen: false },
	type:   null,
	isOpen: false,
};

const HANDLERS = {
	...BladeInfo.HANDLERS,
	[BLADE_ACTIONS.OPEN_BLADE]:setBladeOpen,
	[BLADE_ACTIONS.CLOSE_BLADE]:setBladeClose,
};

function setBladeOpen(state, action){
	return {
		...state,
		type:   action.payload.blade,
		extra:  action.payload.extra,
		isOpen: true,
	};
}

function setBladeClose(state, action){
	return {
		...state,
		isOpen: false,
	};
}

export const REDUCERS = {
	setBladeOpen,
	setBladeClose,
};

export default createReducer(IT, HANDLERS);
